// English copy dictionary — structured for future French (fr) translation.
export const COPY = {
  siteName: "Witness Your Vote",
  siteRegion: "Ontario",
  slogan: "Vote privately. Witness independently. Verify the count.",
  supporting:
    "Witness Your Vote creates an independent, securely preserved record of eligible electors who voluntarily declare which municipal candidate they voted for.",
  headline: "YOUR VOTE IS SECRET. YOUR ELECTION SHOULD BE VERIFIABLE.",
  principle:
    "We do not need every voter to participate. We need enough verified witnesses to identify a result that may not be mathematically possible. Any apparent discrepancy must then be independently reviewed through the proper legal and election processes.",
  ballotWarning:
    "Never provide your voting PIN, password, Voter Information Letter, ballot screenshot, ballot photograph or voting credentials. NEVER UPLOAD YOUR BALLOT.",
  disclaimers: {
    independent:
      "Witness Your Vote is an independent initiative. It is not an official voting system and is not operated by Elections Canada, Elections Ontario, the City of Kawartha Lakes or any other Ontario municipality.",
    notReplacement:
      "Witness Your Vote does not replace the official ballot, official election result, statutory recount or court process.",
    voluntary:
      "Participation is voluntary. No person is required to disclose how they voted.",
    governance:
      "Witness Your Vote is an independent initiative. Participating candidates receive access to public campaign tools but do not control the private voter-declaration database or evidence-verification process.",
  },
  neverCollect: [
    "Voting PINs or passwords",
    "Voter Information Letters",
    "Ballot photos, screenshots or videos",
    "Access to any voting account",
    "Social Insurance Numbers",
    "Banking or payment information",
  ],
};

export const DEFAULT_STATEMENTS = [
  "I am an eligible elector for this municipal election and was entitled to vote in it.",
  "I personally cast my vote in this election using an authorized voting method.",
  "I am voluntarily declaring the candidate for whom I voted. No one has required me to do so.",
  "I voted for the candidate named in this declaration.",
  "The information I have provided in this declaration is true and accurate to the best of my knowledge.",
  "I have not been paid, pressured, or coerced to make this declaration or to vote for any candidate.",
  "I understand that this declaration does not replace the official ballot, official election result, statutory recount or court process.",
  "I understand that my declaration will be securely retained as evidence and may be used in independent verification after voting closes.",
  "I have not provided, and will never provide, my voting PIN, password, Voter Information Letter, ballot photograph, ballot screenshot or any voting credentials to this platform.",
];
